export default ({ request }) => ({

  // 供应商银行账户相关接口
  scmInfoBankListApi(data) {
    return request({
      url: '/digitalCenter/scmInfo/bank/list',
      method: 'post',
      data
    })
  },
  scmInfoBankDetailApi(data) {
    return request({
      url: '/digitalCenter/scmInfo/bank/detail',
      method: 'post',
      data
    })
  },
  scmInfoBankDelApi(data) {
    return request({
      url: '/digitalCenter/scmInfo/bank/del',
      method: 'post',
      data
    })
  },
  scmInfoBankSaveApi(data) {
    return request({
      url: '/digitalCenter/scmInfo/bank/save',
      method: 'post',
      data
    })
  }
})
